import { useCallback, useMemo } from "react"

import {
  sendNativeMessage,
  type NativeOperationType,
  type NativeSettingType,
} from "@/utils/nativeBridge"

export function useNativeBridge() {
  const isWebView = useMemo(() => {
    return new URLSearchParams(window.location.search).get("mode") === "webview"
  }, [])

  const notifySettingChanged = useCallback(
    (setting: NativeSettingType, operation: NativeOperationType) => {
      if (!isWebView) {
        return false
      }

      return sendNativeMessage({ type: "settingChanged", setting, operation })
    },
    [isWebView],
  )

  return { isWebView, notifySettingChanged }
}
